import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorComponent } from './paginator.component';

/**
 * Módulo del paginador reutilizable.
 *
 * Uso desde otro módulo:
 *   imports: [PaginatorModule]
 *
 * Uso desde plantilla:
 *   <app-paginator
 *     [total]="total"
 *     [page]="page"
 *     [pageSize]="pageSize"
 *     [disabled]="isLoading"
 *     (pageChange)="onPageChange($event)"
 *     (pageSizeChange)="onPageSizeChange($event)">
 *   </app-paginator>
 *
 * @version: 19/05/2026_1
 */
@NgModule({
  declarations: [PaginatorComponent],
  imports: [CommonModule],
  exports: [PaginatorComponent]
})
export class PaginatorModule {}